var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-magnifier'></i> Browse"
    }
  }, [_c('div', {
    staticClass: "row d-flex align-items-center mb-3 justify-content-md-between spaced"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-lg-4 mt-2"
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFilter),
      expression: "searchFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pencarian"
    },
    domProps: {
      "value": (_vm.searchFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFilter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-lg-4 mt-2"
  }, [_c('div', {}, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.jnijin,
      "option-value": "id_ijin",
      "option-text": "nama_ijin",
      "name": "Jenis Perizinan",
      "placeholder": "-- Pilih Jenis Perijinan --"
    },
    model: {
      value: (_vm.jnperijinan),
      callback: function($$v) {
        _vm.jnperijinan = $$v
      },
      expression: "jnperijinan"
    }
  })], 1)])]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    staticStyle: {
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "cursor": "pointer",
      "vertical-align": "baseline"
    }
  }, [_c('th', {
    on: {
      "click": function($event) {
        _vm.sort('NM_PERUSAHAAN')
      }
    }
  }, [_vm._v("Nama Perusahaan "), _c('i', {
    staticClass: "fa fa-arrows-v"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_mohon')
      }
    }
  }, [_vm._v("No Mohon "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_setuju')
      }
    }
  }, [_vm._v("No Setuju "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('nama_ijin')
      }
    }
  }, [_vm._v("Jenis Izin"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('status')
      }
    }
  }, [_vm._v("Status"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageOfItems), function(brow) {
    return _c('tr', {
      key: brow.id_permohonan
    }, [_c('td', [_vm._v(_vm._s(brow.NM_PERUSAHAAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.no_mohon) + " "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(brow.tgl_mohon))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.no_setuju) + " "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(brow.tgl_setuju))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.nama_ijin))]), _vm._v(" "), _c('td', {
      style: ('background-color:' + _vm.tes(brow.status))
    }, [_vm._v(_vm._s(brow.ur_status))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": '/brows/detilbrows/' + brow.id_permohonan,
        "title": "Detil Pengajuan"
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "title": "Catatan Petugas",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opencatatan(brow.id_permohonan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-list-ul"
    })]), _vm._v(" "), ((brow.status != 99 && !((brow.id_ijin == 31 || brow.id_ijin == 32 || brow.id_ijin == 33 || brow.id_ijin == 34 || brow.id_ijin == 35 || brow.id_ijin == 36 || brow.id_ijin == 37 || brow.id_ijin == 38 || brow.id_ijin == 44 || brow.id_ijin == 13) && brow.fl_setuju == 'Y') && !((brow.id_ijin == 27 || brow.id_ijin == 30 || brow.id_ijin == 46 || brow.id_ijin == 47) && brow.fl_setuju == 'T' || (brow.id_ijin == 45 && brow.status == '91' && brow.fl_setuju == 'R')) && brow.no_setuju !== null && brow.nm_file === null || (brow.id_ijin == 49 && brow.status == '98') || (brow.id_ijin == 50 && brow.status == '98'))) ? _c('a', {
      attrs: {
        "title": "Print Izin",
        "href": _vm.$http.options.base + '/api/pdf/' + _vm.user + '/' + brow.id_permohonan,
        "target": "_blank"
      }
    }, [_c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    })])]) : _vm._e(), _vm._v(" "), (brow.no_setuju !== null && brow.nm_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Print Izin",
        "href": _vm.$http.options.base + brow.url_file + '/' + brow.nm_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    })]) : _vm._e(), _vm._v(" "), (brow.status == '90') ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "Ajukan Kembali"
      },
      on: {
        "click": function($event) {
          _vm.opennew(brow.id_permohonan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s((brow.id_ijin == 27 || brow.id_ijin == 30) && brow.fl_setuju == 'Y' ? 'Diperiksa' : ((brow.id_ijin == 27 || brow.id_ijin == 30) && brow.fl_setuju == 'T' ? 'Tidak diperiksa' : brow.fl_setuju)))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 pb-0 pt-3"
  }, [_c('jw-pagination', {
    attrs: {
      "items": _vm.filteredData
    },
    on: {
      "changePage": _vm.onChangePage
    }
  })], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "fade": "",
      "hide-footer": "",
      "title": "Catatan Petugas",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ModalCatatan = false
      }
    },
    model: {
      value: (_vm.ModalCatatan),
      callback: function($$v) {
        _vm.ModalCatatan = $$v
      },
      expression: "ModalCatatan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', {
    staticClass: "align-middle"
  }, [_c('th', [_vm._v("Nama Pegawai")]), _vm._v(" "), _c('th', [_vm._v("Level Pemeriksa")]), _vm._v(" "), _c('th', [_vm._v("Catatan")]), _vm._v(" "), _c('th', [_vm._v("Wkt Selesai")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.catatan), function(catat) {
    return _c('tr', {
      key: catat.NAMA
    }, [_c('td', [_vm._v(_vm._s(catat.NAMA))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(catat.ur_pemeriksa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(catat.catatan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(catat.wk_selesai))])])
  }))])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12b01828","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Brows/ListBrowsV2.vue
// module id = 291
// module chunks = 0